export interface ClientSalesReturnList {
    items: SalesReturn[]
    statistics: SalesReturn[]
    total_items: number
    total_pages: number
    current_page: number
  }
  
  export interface SalesReturn {
    id: number
    invoice_id: number
    company_id: number
    tenant_id: number
    client_id: number
    number: number
    number_prefix: string
    sales_rep: number
    total_base_amount_in_minor_currency: number
    total_tax_amount_in_minor_currency: number
    total_amount_in_minor_currency: number
    sales_return_date: string
    track_mode: string
    migration_id: string
    created_by: number
    created_date: string
    updated_by: number
    updated_date: string
    return_reason: string
    is_void: boolean
    void_reason: string
    uuid: string
    invoice_number_prefix : string
    invoiceNumbers : string[]
    sales_return_line_items: SalesReturnLineItem[]
    sales_return_tax_line_items: SalesReturnTaxLineItem[]
  }
  
  export interface SalesReturnLineItem {
    id: number
    sales_return_id: number
    invoice_line_id: number
    description: string
    type: string
    net_unit_cost_in_minor_currency: number
    quantity: number
    net_cost_in_minor_currency: number
    total_tax_in_minor_currency: number
    total_amount_in_minor_currency: number
    service_id: number
    charge_master_id: number
    product_id: number
  }
  
  export interface SalesReturnTaxLineItem {
    id: number
    sales_return_id: number
    sales_return_line_id: number
    tax_regime_name: string
    tax_line_id: number
    tax_name_primary_language: string
    tax_name_secondary_language: string
    rate: number
    total_tax_amount_in_minor_currency: number
  }

  export interface SalesReturnServices {
    invoice_line_id: number
    name_primary_language: string
    name_secondary_language: string
    invoice_amount: number
    sales_return_amount:number
    description:string
    quantity: number
    is_total_column:boolean
    has_total_cell:boolean
    has_tax_cell:boolean
    type:string
    sku_return_reason_id?: number
  }

  export interface SaleReturnCalculationRequest {
    sales_rep: number
    sales_return_date: string
    return_reason: string
    return_comments: string
    sales_return_line_items: SalesReturnLineItemRequest[]
    refund_mode: RefundMode
    online_refund_payment_id: number
  }
  
  export interface SalesReturnLineItemRequest {
    invoice_line_id: number
    description: string
    total_amount_in_minor_currency: number
    rounded_total_amount_in_minor_currency?: number
    quantity: number
    sku_return_reason_id?: number
  }

  export interface voidSalesReturnRequest {
    void_reason: string
  }

export enum RefundMode
{
    Online = 1,
    Offline = 2,
    Device = 3,
    Credit = 4,
}

  
  